function dict () {
	const src = {};
	src.Products = {
		"Null": {
			"isNull": true,
			"appTitle": "Заявка на страхование",
		},
		"Kasko": {
			"title": "КАСКО",
			"appTitle": "Заявка на страхование КАСКО",
		},
		"AnticrisisKasko": {
			"title": "Антикризисное КАСКО",
			"appTitle": "Заявка на страхование Антикризисное КАСКО",
		},
		"Osago": {
			"title": "ОСАГО",
			"appTitle": "Заявка на страхование ОСАГО",
		},
		"Dsago": {
			"title": "ДСАГО",
			"appTitle": "Заявка на страхование ДСАГО",
		},
		"GreenCard": {
			"title": "Зеленая карта",
			"appTitle": "Заявка на «Зеленую карту»",
		},
		"Crash": {
			"title": "Защита от ДТП",
			"appTitle": "Заявка на «Защиту от ДТП»",
		},
		"Travel": {
			"title": "Страхование поездок",
		},
		"Travel2": {
			"title": "Страхование поездок",
		},
		"Building": {
			"title": "Дом",
			"appTitle": "Заявка на страхование дома",
		},
		"BuildingProperty": {
			"title": "Домашнее имущество",
			"appTitle": "Заявка на страхование домашнего имущества",
		},
		"Flat": {
			"title": "Квартира",
			"appTitle": "Заявка на страхование квартиры",
		},
		"Mortgage": {
			"title": "Ипотека",
			"appTitle": "Заявка на ипотечное страхование",
			"hasRegionField": true,
			"isMortgage": true,
		},
		"TitleInsurance": {
			"title": "Титульное страхование",
			"appTitle": "Заявка на титульное страхование",
			"hasRegionField": true,
		},
		"Life": {
			"title": "Страхование жизни",
			"appTitle": "Заявка на страхование жизни",
		},
		"InvestmentInsurance": {
			"title": "Инвестиционное страхование",
			"appTitle": "Заявка на инвестиционное страхование",
		},
		"FirstClassPolicy": {
			"title": "Первоклассный полис",
			"appTitle": "Заявка на «Первоклассный полис»",
		},
		"CompulsoryMedicalInsurance": {
			"title": "Обязательное медицинское страхование",
			"appTitle": "Заявка на обязательное медицинское страхование",
		},
		"VoluntaryMedicalInsurance": {
			"title": "Добровольное медицинское страхование",
			"appTitle": "Заявка на добровольное медицинское страхование",
			"hasRegionField": true,
		},
		"Accident": {
			"title": "Страхование от несчастных случаев",
			"appTitle": "Заявка на страхование от НС",
		},
		"VisitorFromAbroad": {
			"title": "Страхование гостей из-за рубежа",
			"appTitle": "Заявка на страхование гостей из-за рубежа",
		},
		"YachtOrBoat": {
			"title": "Страхование яхт и катеров",
			"appTitle": "Заявка на страхование яхт и катеров",
		},
		"CompensatoryPayment": {
			"title": "Компенсационные выплаты",
			"appTitle": "Заявка на комплексные выплаты",
		},
		"Animal": {
			"title": "Страхование животных",
			"appTitle": "Заявка на страхование животных",
		},
		"RoadAssistance": {
			"title": "Помощь на дороге",
			"appTitle": "Заявка на страхование по программе «Помощь в дороге»",
		},
		"RgsBusinessAuto": {
			"title": "Росгосстрах-Бизнес «Авто»",
			"appTitle": "Заявка на страхование Росгосстрах-Бизнес «Авто»",
		},
		"RgsBusinessHealth": {
			"title": "Росгосстрах-Бизнес «Здоровье»",
			"appTitle": "Заявка на страхование Росгосстрах-Бизнес «Здоровье»",
		},
		"RgsBusinessResponsibility": {
			"title": "Росгосстрах-Бизнес «ОТВЕТСТВЕННОСТЬ»",
			"appTitle": "Заявка на страхование Росгосстрах-Бизнес «ОТВЕТСТВЕННОСТЬ»",
		},
		"CompanyKasko": {
			"title": "КАСКО для компаний",
			"appTitle": "Заявка на страхование КАСКО для компаний",
		},
		"CompanyDsago": {
			"title": "ДСАГО для компаний",
			"appTitle": "Заявка на страхование ДСАГО для компаний",
		},
		"CompanyProperty": {
			"title": "Страхование имущества предприятий",
			"appTitle": "Заявка на страхование имущества предприятий",
			"isCompanyProperty": true,
		},
		"CompanyCargo": {
			"title": "Транспортное страхование грузов",
			"appTitle": "Заявка на транспортное страхование грузов",
		},
		"CompanySpaceActivity": {
			"title": "Страхование рисков космической деятельности",
			"appTitle": "Заявка на страхование рисков космической деятельности",
		},
		"CompanyTitleInsurance": {
			"title": "Титульное страхование для компаний",
			"appTitle": "Заявка на титульное страхование для компаний",
		},
		"CompanyRailwayTransportation": {
			"title": "Страхование средств железнодорожного транспорта",
			"appTitle": "Заявка на страхование средств железнодорожного транспорта",
		},
		"CompanyVoluntaryMedicalInsurance": {
			"title": "Добровольное медицинское страхование",
			"appTitle": "Заявка на добровольное медицинское страхование",
			"hasRegionField": true,
		},
		"CompanyAccident": {
			"title": "Страхование от несчастного случая",
			"appTitle": "Заявка на страхование от несчастного случая",
			"hasRegionField": true,
		},
		"CompanyLife": {
			"title": "Страхование жизни",
			"appTitle": "Заявка на страхование жизни для компаний",
		},
		"CompanyResponsibility": {
			"title": "Страхование ответственности",
			"appTitle": "Заявка на страхование ответственности",
		},
		"CompanyAgriculture": {
			"title": "Страхование сельскохозяйственных рисков",
			"appTitle": "Заявка на страхование сельскохозяйственных рисков",
		},
		"CompanySeeOrRiverCraft": {
			"title": "Страхование морских и речных судов",
			"appTitle": "Заявка на страхование морских и речных судов",
		},
		"CompanyAircraft": {
			"title": "Страхование воздушных судов",
			"appTitle": "Заявка на страхование воздушных судов",
		},
		"CompanyYachtOrBoat": {
			"title": "Страхование яхт и катеров",
			"appTitle": "Заявка на страхование яхт и катеров для компаний",
		},
		"CompanyReinsurance": {
			"title": "Перестрахование",
			"appTitle": "Заявка на перестрахование",
		},
		"CompanyInsurance": {
			"title": "Страхование компаний",
			"appTitle": "Заявка на страхование компаний",
		},
		"CompanyOsago": {
			"title": "ОСАГО для компаний",
			"appTitle": "Заявка на страхование ОСАГО для компаний",
		},
		"CompanyAutoInsurance": {
			"title": "Автострахование для компаний",
			"appTitle": "Заявка на автострахование для компаний",
		},
		"CompanyGreenCard": {
			"title": "Зеленая карта для компаний",
			"appTitle": "Заявка на «Зеленую карту» для компаний",
		},
		"CompanyHazardousFacilitiesSafetyInsurance": {
			"title": "Страхование безопасности опасных объектов для компаний",
			"appTitle": "Заявка на cтрахование безопасности опасных объектов для компаний",
		},
		"CompanyFoodIndustryAndAgribusinessInsurance": {
			"title": "Страхование предприятий пищевой промышленности и АПК для компаний",
			// eslint-disable-next-line max-len
			"appTitle": "Заявка на страхование предприятий пищевой промышленности и АПК для компаний",
		},
		"CompanyConstructionInsurance": {
			"title": "Страхование строительно-монтажных и других технических рисков для компаний",
			// eslint-disable-next-line max-len
			"appTitle": "Заявка на комбинированное страхование cтроительно-монтажных и других технических рисков для компаний",
		},
		"CompanyContainerInsurance": {
			"title": "Страхование контейнеров для компаний",
			"appTitle": "Заявка на страхование контейнеров для компаний",
		},
		"CompanyFuelAndEnergyComplexInsurance": {
			"title": "Страхование рисков предприятий ТЭК для компаний",
			"appTitle": "Заявка на комбинированное страхование рисков предприятий ТЭК для компаний",
		},
		"CompanyClinicalTrialsInsurance": {
			"title": "Страхование рисков при проведении клинических исследований",
			"appTitle": "Заявка на страхование рисков при проведении клинических исследований",
		},
		"CompanyPortOperatorLiabilityInsurance": {
			"title": "Страхование ответственности портовых операторов",
			"appTitle": "Заявка на страхование ответственности портовых операторов",
		},
		"CompanyCarrierLiabilityInsurance": {
			"title": "Страхование ответственности грузоперевозчика",
			"appTitle": "Заявка на страхование ответственности грузоперевозчика",
		},
		"CompanyForwarderLiabilityInsurance": {
			"title": "Страхование ответственности экспедитора",
			"appTitle": "Заявка на страхование ответственности экспедитора",
		},
		"CompanyCustomsOperatorLiabilityInsurance": {
			"title": "Страхование ответственности таможенных операторов",
			"appTitle": "Заявка на страхование ответственности таможенных операторов",
		},
		"Opo": {
			"title": "ГО ОПО",
			"appTitle": "Заявка на обязательное страхование ОПО",
			"isOpo": true,
			"hasRegionField": true,
		},
		"OpoHydraulicStructures": {
			"title": "ГО ГТС",
			"appTitle": "Заявка на ОПО",
			"isOpo": true,
			"hasRegionField": true,
		},
		"OpoMandatoryInsurance": {
			"title": "Обязательное страхование ГО владельцев опасных объектов",
			"appTitle": "Заявка на ОСГОПП",
			"isOpo": true,
			"hasRegionField": true,
		},
		"QuestionPennant": {
			"title": "Ваш вопрос",
			"appTitle": "Ваш вопрос",
			"isQuestionPennant": true,
		},
	};

	src.Regions = [];

	return src;
}

module.exports = dict;
